// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const ZoomHelp = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M10.125 1.25c-4.894 0-8.875 3.981-8.875 8.875S5.231 19 10.125 19 19 15.019 19 10.125 15.019 1.25 10.125 1.25Zm0 18.75C4.68 20 .25 15.57.25 10.125S4.68.25 10.125.25 20 4.68 20 10.125 15.57 20 10.125 20Zm-.5-6.983v-.768c0-1.306.966-2.018 1.67-2.538.257-.19.499-.368.613-.517.448-.584.592-.966.592-1.57a2.378 2.378 0 0 0-2.375-2.375A2.378 2.378 0 0 0 7.75 7.624a.5.5 0 0 1-1 0 3.379 3.379 0 0 1 3.375-3.375A3.379 3.379 0 0 1 13.5 7.624c0 .83-.216 1.42-.799 2.18-.2.26-.497.48-.812.711-.621.459-1.264.933-1.264 1.734v.768a.508.508 0 0 1-.5.49.492.492 0 0 1-.5-.49Zm.5 3.233a.75.75 0 1 1 .748-.753v.004a.75.75 0 0 1-.749.749Z"
			fill="#fff"
		/>
	</svg>
);
export default ZoomHelp;
